import { render, staticRenderFns } from "./JobBoardDashboard.vue?vue&type=template&id=36fed222&"
import script from "./JobBoardDashboard.vue?vue&type=script&lang=js&"
export * from "./JobBoardDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports